import { render } from "./PageNews.vue?vue&type=template&id=d40bf23c&scoped=true"
import script from "./PageNews.vue?vue&type=script&lang=js"
export * from "./PageNews.vue?vue&type=script&lang=js"

import "./PageNews.vue?vue&type=style&index=0&id=d40bf23c&scoped=true&lang=css"
import "./PageNews.vue?vue&type=style&index=1&id=d40bf23c&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d40bf23c"]])

export default __exports__